/* app/js/src/components/calendar/calendar-header/calendar-header-dropdown/calendar-header-dropdown.component.scss */
div section ul {
  max-width: 30vw;
  z-index: 9;
  max-height: 40vh;
  overflow-y: scroll;
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  list-style-type: none;
  padding: 0;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
}
.cursor-pointer {
  cursor: pointer;
}
div section ul::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div section ul::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
div section ul::-webkit-scrollbar-corner {
  background: transparent;
}
div section ul::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
div section ul::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
div section ul::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
div section ul::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
div section ul::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
div section ul::-webkit-scrollbar-thumb {
  border-width: 0;
}
div label {
  color: #7d8fa1;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: normal;
  font-size: 0.85em;
  min-width: 90px;
  white-space: nowrap;
}
div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  margin-bottom: 5px;
}
div label {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
div .clear-preroll-list {
  white-space: nowrap;
  border-top: 1px solid #EEF2F6;
}
div .clear-preroll-list .clear-prerolls-title {
  color: #ef5350;
  font-weight: bold;
  padding-top: 5px;
  padding-bottom: 5px;
}
div section {
  -webkit-flex: 5 0 0;
  -ms-flex: 5 0 0;
  flex: 5 0 0;
  position: relative;
}
div section span {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #40c4ff;
  height: inherit;
  cursor: pointer;
  text-align: left;
}
div section span i {
  display: block;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-style: normal;
}
div section span i.icon-arrow-down {
  margin: 3px 0 0 5px;
}
div section span i.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 20px;
}
div section span svg {
  display: block;
}
div section ul {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: scroll;
  position: absolute;
  top: 16px;
  right: 0;
  width: auto;
  text-align: left;
}
div section ul::-webkit-scrollbar {
  width: 3px;
}
div section ul li {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
div section ul li i {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  max-width: 100px;
  width: 100px;
  height: 12px;
  margin-right: 9px;
  margin-left: 12px;
}
div section ul li i svg {
  max-width: 10px;
  width: 10px;
  height: 12px;
}
div section ul li i svg path {
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
  -ms-transform: translateX(-10px);
  -webkit-transform: translateX(-10px);
  transform: translateX(-10px);
  opacity: 0;
  fill: #232f3a;
}
div section ul li span {
  -webkit-flex: 12 0 0;
  -ms-flex: 12 0 0;
  flex: 12 0 0;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
  display: block;
}
div section ul li span.show-title {
  text-align: left;
  color: #879baf;
}
div section ul li span.show-title:hover {
  color: #232f3a;
}
div section ul li span.show-title .broadcast-skip-blocked-hint {
  display: inline;
  margin-left: 6px;
  font-size: 12px;
  font-weight: normal;
  color: #607d8b;
  white-space: normal;
}
div section ul li span.duration {
  margin-left: 20px;
  margin-right: 5px;
  text-align: right;
}
div section ul li:hover {
  background-color: #eef2f6;
}
div section ul li:hover i svg path {
  -ms-transform: translateX(0px);
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
  opacity: 0.5;
}
div section ul li.skip-option-disabled {
  cursor: not-allowed;
}
div section ul li.skip-option-disabled .show-title {
  color: #647586;
}
div section ul li.selected i svg path {
  -ms-transform: translateX(0px);
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
  opacity: 1;
}
div section ul li.selected i.multiple::before {
  border-color: #879baf;
}
/*# sourceMappingURL=calendar-header-dropdown.component.css.map */
